<div id="footer-container">
  <div class="py-3 d-flex flex-column align-items-center mh-text-on-dark-bg">
    <img id="img-ignite-growth-platform-btm" src="{{ footerContents.logoPath }}" alt="{{ footerContents.altText }}" class="py-2 img-fluid height-65" />
    <p id="footer-copyright-text" class="text-center pt-2 text-white font-size-12 mb-1">
      <span id="footer-copyright-text-primary" class="d-block">&#169; {{ copyrightTextPrimary }}</span>
      <span id="footer-copyright-text-secondary">{{ copyrightTextSecondary }}</span>
    </p>
  </div>
</div>
